import script from "./AdminTestimonyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTestimonyInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdminTestimonyInfo.vue?vue&type=style&index=0&id=184bc403&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184bc403"]])

export default __exports__